// src/router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'
import help from '../components/help.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomePage',
    redirect: { name: 'help' }
  },
  {
    path: '/help/:language?/:menuId?',
    name: 'help',
    component: help
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})
// 路由前置守卫，优先处理URL转译
router.beforeEach((to, from, next) => {
  const currentHref = window.location.href;
  if (currentHref.includes('%23')) {
    const correctHref = currentHref.replace(/%23/g, '#');
    window.history.replaceState(null, document.title, correctHref);
    // 重新解析正确的路由
    next({ path: window.location.hash.replace('#/', '') });
  } else {
    next();
  }
});

export default router